// src/components/CookAI/LegalPages/TermsOfUse.tsx
import React from "react";
import { ColorTheme } from "../../../themes/colors";
import { getLegalStyles } from "../../../themes/styles/legal";
import { useLanguage } from "../../../i18n/LanguageContext";
import { legalTranslations } from "../../../i18n/legalTranslations";
import LanguageDropdown from "../Navigaton/LanguageDropdown";

interface TermsOfUseProps {
    theme: ColorTheme;
    onBack: () => void;
}

const TermsOfUse: React.FC<TermsOfUseProps> = ({ theme, onBack }) => {
    const styles = getLegalStyles(theme);
    const { language } = useLanguage();
    const l = legalTranslations[language];
    const t = l.terms;

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={styles.header}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
                        <button
                            style={styles.backButton}
                            onClick={onBack}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-2px)";
                                e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.2)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
                            }}
                        >
                            {l.backButton}
                        </button>
                        <LanguageDropdown theme={theme} />
                    </div>
                    <h1 style={styles.title}>
                        <span style={styles.gradientText}>{t.pageTitle}</span>
                    </h1>
                    <p style={styles.lastUpdated}>{l.lastUpdated}</p>
                </div>

                <div style={styles.section}>
                    <p style={styles.paragraph}>
                        {t.intro.split('Cook AI')[0]}
                        <span style={styles.highlight}>Cook AI</span>
                        {t.intro.split('Cook AI')[1]}
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s1Title}</h2>
                    <p style={styles.paragraph}>{t.s1Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s2Title}</h2>
                    <p style={styles.paragraph}>{t.s2Intro}</p>
                    <ul style={styles.list}>
                        {t.s2Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.warningBox}>
                    <div style={styles.warningTitle}>{t.warningTitle}</div>
                    <p style={styles.warningText}>{t.warningText}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s3Title}</h2>
                    <p style={styles.paragraph}>{t.s3Intro}</p>
                    <ul style={styles.list}>
                        {t.s3Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s4Title}</h2>
                    <p style={styles.paragraph}>{t.s4Intro}</p>
                    <ul style={styles.list}>
                        {t.s4Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s5Title}</h2>
                    <p style={styles.paragraph}><strong>{t.s5Intro}</strong></p>
                    <ul style={styles.list}>
                        {t.s5Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                    <p style={styles.paragraph}>{t.s5Note}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s6Title}</h2>
                    <p style={styles.paragraph}>{t.s6Intro}</p>
                    <ul style={styles.list}>
                        {t.s6Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                    <p style={styles.paragraph}>{t.s6Note}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s7Title}</h2>
                    <p style={styles.paragraph}>{t.s7Intro}</p>
                    <ul style={styles.list}>
                        {t.s7Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s8Title}</h2>
                    <p style={styles.paragraph}>{t.s8Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s9Title}</h2>
                    <p style={styles.paragraph}>{t.s9Intro}</p>
                    <ul style={styles.list}>
                        {t.s9Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s10Title}</h2>
                    <p style={styles.paragraph}>{t.s10Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s11Title}</h2>
                    <p style={styles.paragraph}>{t.s11Text}</p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>{t.s12Title}</h2>
                    <p style={styles.paragraph}>{t.s12Intro}</p>
                    <ul style={styles.list}>
                        {t.s12Items.map((item, i) => (
                            <li key={i} style={styles.listItem}>{item}</li>
                        ))}
                    </ul>
                    <p style={styles.paragraph}>{t.s12Note}</p>
                </div>

                <div style={styles.contactBox}>
                    <h2 style={styles.contactTitle}>{t.contactTitle}</h2>
                    <p style={styles.contactText}>{t.contactText}</p>
                    <a
                        href="mailto:thecookaiapp@gmail.com"
                        style={styles.link}
                    >
                        thecookaiapp@gmail.com
                    </a>
                    <p style={{ ...styles.contactText, marginTop: "16px" }}>{t.contactText2}</p>
                </div>
            </div>
        </div>
    );
};

export default TermsOfUse;
